import React, { useState } from "react";
import "./Withdraw.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import With_Dep_Ammout_card from "../Common/Common_Component/With_Dep_Ammout_card/With_Dep_Ammout_card";
import Payment_Method_Cards from "../Common/Common_Component/Payment_Method_Cards/Payment_Method_Cards";
import Bank_Card_Content from "./Bank_Card_Content/Bank_Card_Content";
import UPI_QR_Content from "./UPI_QR_Content/UPI_QR_Content";
import USDT_Content from "./USDT_Content/USDT_Content";
import Withdraw_bank_info from "./Withdraw_bank_info/Withdraw_bank_info";
import Withdrawal_History from "./Withdrawal_History/Withdrawal_History";
import No_data from "../Common/No_data/No_data";

function Withdraw() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="Withdraw">
      <Common_white_header
        headingText={"Withdraw"}
        historyTitle={" Withdrawal history"}
        historyLink={"/withdrawal-history"}
      />

      <div className="container">
        <With_Dep_Ammout_card />


        <Bank_Card_Content />
        <Withdraw_bank_info type={activeIndex} />

        <Withdrawal_History />


      </div>
    </div>
  );
}

export default Withdraw;
